import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';

import { GoalStatisticsService } from '../../service/statistics/statistics.service';
import { Subscription, tap } from 'rxjs';

@Component({
    selector: 'app-goal-tile-streaks',
    templateUrl: './tile-streaks.component.html',
    styleUrls: ['./tile-streaks.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GoalTileStreaksComponent implements OnInit, OnDestroy {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly goalStatisticsService = inject(GoalStatisticsService);
    private readonly subscriptions$ = new Subscription();

    ngOnInit() {
        this.subscriptions$.add(this.goalStatisticsService.updates.pipe(tap(() => this.changeDetectorRef.detectChanges())).subscribe());
    }

    ngOnDestroy() {
        this.subscriptions$.unsubscribe();
    }

    /**
     * Current Streaks in a row
     */
    get current(): number {
        return this.goalStatisticsService.statistics.streak.current;
    }

    /**
     * Best Streaks in a row
     */
    get best(): number {
        return this.goalStatisticsService.statistics.streak.best;
    }

    get statistics() {
        return this.goalStatisticsService.statistics;
    }
}
